/* ==========================================================================
   BatID · Opiniones
   Este archivo se carga una vez por CADA seccion que lo pide, asi que todas
   las funciones llevan candado (dataset.batListo) para no montarse dos veces.
   Leccion aprendida: sin candado, el listado se duplicaba por cada seccion.
   ========================================================================== */
(function () {
  'use strict';

  /* --- Estrellas clicables del formulario --------------------------------- */
  function initSelector(raiz) {
    (raiz || document).querySelectorAll('[data-bat-selector]').forEach(function (caja) {
      if (caja.dataset.batListo) return;
      caja.dataset.batListo = '1';

      var estrellas = Array.prototype.slice.call(
        caja.querySelectorAll('.bat-esc__estrella')
      );
      if (!estrellas.length) return;

      function pintar(hasta) {
        estrellas.forEach(function (el) {
          var v = parseInt(el.dataset.valor, 10);
          el.classList.toggle('bat-esc__estrella--on', v <= hasta);
        });
      }

      function marcada() {
        var m = caja.querySelector('.bat-esc__radio:checked');
        return m ? parseInt(m.value, 10) : 0;
      }

      estrellas.forEach(function (el) {
        var v = parseInt(el.dataset.valor, 10);
        el.addEventListener('mouseenter', function () { pintar(v); });
        el.addEventListener('click', function () { pintar(v); });
      });

      caja.addEventListener('mouseleave', function () { pintar(marcada()); });
      caja.addEventListener('change', function () { pintar(marcada()); });

      // Ninguna marcada al abrir: el respaldo CSS marca la 5 por el "required",
      // asi que arrancamos en 0 y que elija el cliente.
      var m = caja.querySelector('.bat-esc__radio:checked');
      if (m) m.checked = false;
      pintar(0);
    });
  }

  /* --- Boton "Ver mas opiniones" ------------------------------------------ */
  function initVerMas(raiz) {
    (raiz || document).querySelectorAll('[data-bat-rejilla]').forEach(function (rejilla) {
      if (rejilla.dataset.batListo) return;
      rejilla.dataset.batListo = '1';

      var limite = parseInt(rejilla.dataset.visibles, 10);
      if (!limite || limite < 1) return;

      var tarjetas = Array.prototype.slice.call(
        rejilla.querySelectorAll('.bat-op__t')
      );
      if (tarjetas.length <= limite) return;

      tarjetas.forEach(function (t, i) {
        if (i >= limite) t.classList.add('bat-op__t--oculta');
      });

      var seccion = rejilla.closest('.bat-op');
      var boton = seccion && seccion.querySelector('[data-bat-mas]');
      if (!boton) return;

      boton.addEventListener('click', function () {
        tarjetas.forEach(function (t) { t.classList.remove('bat-op__t--oculta'); });
        boton.remove();
      });
    });
  }

  /* --- Resumen bajo el titulo del producto -------------------------------- */
  /* Lee los datos que emite la seccion de opiniones. Si esa seccion no esta
     en la pagina, el resumen se esconde solo en vez de mentir con un 5,0. */
  function initResumen(raiz) {
    var resumenes = (raiz || document).querySelectorAll('[data-bat-resumen]');
    if (!resumenes.length) return;

    var fuente = document.querySelector('[data-bat-opiniones-datos]');
    var datos = null;
    if (fuente) {
      try { datos = JSON.parse(fuente.textContent); } catch (e) { datos = null; }
    }

    resumenes.forEach(function (el) {
      if (el.dataset.batListo) return;
      el.dataset.batListo = '1';

      if (el.dataset.modo === 'auto') {
        if (!datos || !datos.total) {
          el.hidden = true;
          return;
        }
        var num = el.querySelector('[data-bat-resumen-cuenta]');
        if (num) {
          num.textContent = '(' + datos.total.toLocaleString('es-ES') + ')';
        }
        pintarEstrellas(el, datos.media);
      }

      // Clic -> baja hasta las opiniones
      el.addEventListener('click', function (ev) {
        var destino = document.getElementById('bat-opiniones');
        if (!destino) return;
        ev.preventDefault();
        destino.scrollIntoView({
          behavior: prefiereQuieto() ? 'auto' : 'smooth',
          block: 'start'
        });
        destino.setAttribute('tabindex', '-1');
        destino.focus({ preventScroll: true });
      });
    });
  }

  function pintarEstrellas(raiz, nota) {
    var svgs = raiz.querySelectorAll('.bat-estrellas__i');
    svgs.forEach(function (svg, i) {
      var resto = nota - i;
      var pct = resto >= 1 ? 100 : (resto > 0 ? Math.round(resto * 100) : 0);
      var path = svg.querySelector('path');
      if (!path) return;
      if (pct === 100) {
        path.setAttribute('fill', 'var(--bat-estrella)');
      } else if (pct === 0) {
        path.setAttribute('fill', 'var(--bat-estrella-vacia)');
      } else {
        var id = 'bat-auto-' + i + '-' + Math.random().toString(36).slice(2, 7);
        var ns = 'http://www.w3.org/2000/svg';
        var defs = document.createElementNS(ns, 'defs');
        var grad = document.createElementNS(ns, 'linearGradient');
        grad.setAttribute('id', id);
        [[pct, 'var(--bat-estrella)'], [pct, 'var(--bat-estrella-vacia)']]
          .forEach(function (par) {
            var stop = document.createElementNS(ns, 'stop');
            stop.setAttribute('offset', par[0] + '%');
            stop.setAttribute('stop-color', par[1]);
            grad.appendChild(stop);
          });
        defs.appendChild(grad);
        svg.insertBefore(defs, svg.firstChild);
        path.setAttribute('fill', 'url(#' + id + ')');
      }
    });
  }

  function prefiereQuieto() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initTodo(raiz) {
    initSelector(raiz);
    initVerMas(raiz);
    initResumen(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }

  // El editor del tema recarga secciones sueltas sin recargar la pagina
  document.addEventListener('shopify:section:load', function (ev) {
    initTodo(ev.target);
    initResumen(document);
  });
})();
